import { getIsQuizOpen } from '@bridebook/web/lib/quiz/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';

const FloristsQuizLazy = lazyComponent(() => import('./florists-quiz'));

const FloristsQuiz = () => {
  const isQuizOpen = useSelector(getIsQuizOpen('florists'));

  if (!isQuizOpen) {
    return null;
  }

  return <FloristsQuizLazy />;
};

export default FloristsQuiz;
